/*
 * Copyright (c) 2022 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Asset } from '@wit/vtv-x-foundation-lib';
import React from 'react';
import Card, { CARDS_DYNAMIC_DIRECTION } from './Card';
import { Spinner } from '.';

interface Props {
  railId: number | string;
  menuItemId?: number;
  className?: string;
  assets?: Asset[];
  showSeriesInfo?: boolean;
  identifyScheduled?: boolean;
  isLoadingAssets?: boolean;
  onCardClick?: (asset: Asset, menuItemId?: number) => void;
}

export default function Grid({
  railId,
  menuItemId,
  className = '',
  assets = [],
  showSeriesInfo,
  identifyScheduled,
  isLoadingAssets,
  onCardClick,
}: Props): JSX.Element {
  return (
    <div className={`rail ${className}`}>
      <div className="rail-grid" id={`Rail___${railId}`}>
        {!isLoadingAssets ? (
          <>
            {assets.map((asset) => (
              <Card
                key={asset.id}
                asset={asset}
                onAssetClick={(elem) => onCardClick && onCardClick(elem, menuItemId)}
                showSeriesInfo={showSeriesInfo}
                identifyScheduled={identifyScheduled}
                dynamicDirection={CARDS_DYNAMIC_DIRECTION.HORIZONTAL}
                ctxId={railId}
              />
            ))}
            <div className="dynamic-content-card fill horizontal" />
          </>
        ) : (
          <div className="loading-rail-assets" id={`Rail_loading___${railId}`}>
            <Spinner isActive />
          </div>
        )}
      </div>
    </div>
  );
}
